import React, { useEffect } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { IApplicationState } from 'components/store/types'
import BackButton from 'components/ui/buttons/BackButton'
import { useTranslation } from 'react-i18next'
import ucfirst from 'utils/ucfirst'
import Container from 'components/ui/Container'
import { getCurrentClinique } from 'components/core/state/selectors'

const mapState = (state: IApplicationState) => ({
  clinique: getCurrentClinique(state),
})
const connector = connect(mapState)
interface Step3ZawinProps extends ConnectedProps<typeof connector> {
  url: string,
}

const Step3Zawin = ({ clinique, url }: Step3ZawinProps) => {
  const { i18n, t } = useTranslation()
  useEffect(() => {
    const script = window.document.createElement('script')
    script.src = 'https://oa.zawin.ch/js/iframe.seamless.min.js'
    script.async = true
    window.document.body.appendChild(script)
  }, [])

  const code = `${i18n.language}/${url.split('/').pop()}`
  return (
    <Container>
      <div className="tw-col-span-12">
        <BackButton step={2} />
        <div className="tw-font-thin tw-mb-5">
          {ucfirst(t('my-appointment-in'))}
          {' '}
          <span className="tw-font-bold">{clinique.title}</span>
        </div>

        <div className="tw-mb-4">
          <iframe title="zawinAgenda" id="zawinAgenda" data-oa-zugangscode={code} />
        </div>
      </div>
    </Container>
  )
}
export default connector(Step3Zawin)
